import { type RequiredMap } from "@pmag/ui-components";
import { type GQLCompatibleArticlesFilter, GQLComponentType } from "@src/graphql.generated";
import { type SessionFilterState } from "@src/pages/compatibilityCheck/components/usageList/UsageListFormSchema";
import { defineMessage, type MessageDescriptor } from "react-intl";

export const createQueryFilterFromSessionState = (filter: SessionFilterState, brandIds: string[]): GQLCompatibleArticlesFilter => {
    let result: GQLCompatibleArticlesFilter = {};

    if (filter.componentGroup) {
        result = { ...result, componentGroupId: { equal: filter.componentGroup } };
    }

    if (filter.modelSpecification) {
        result = { ...result, modelSpecification: { contains: filter.modelSpecification } };
    }

    if (filter.modelYear) {
        const date = new Date(filter.modelYear);
        if (date) result = { ...result, modelYear: { equal: date.getFullYear() } };
    }

    if (brandIds.length > 0) {
        result = { ...result, brandId: { isAnyOf: brandIds } };
    }

    return result;
};

export const isUsageListComponentGroupType = (value?: string): value is GQLComponentType => {
    if (!value) return false;

    return Object.values<string>(GQLComponentType).includes(value);
};

export const componentGroupTypeMap: RequiredMap<GQLComponentType, MessageDescriptor> = {
    Chassis: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.chassis", defaultMessage: "Chassis" }),
    Engine: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.engine", defaultMessage: "Engine" }),
    Fork: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.fork", defaultMessage: "Fork" }),
    Shock: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.shock", defaultMessage: "Shock" }),
    SteeringDamper: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.steeringDamper", defaultMessage: "Steering Damper" }),
    BicycleParts: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.bicycleParts", defaultMessage: "Bicycle Parts" }),
    BicycleAccessories: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.bicycleAccessories", defaultMessage: "Bicycle Accessories" }),
    BicycleGeneral: defineMessage({ id: "sparePartsFinder.componentGroupTypeMap.bicycleGeneral", defaultMessage: "Bicycle General" }),
};
